module.exports = __webpack_public_path__ + "img/gartentor_2.66f10da0.webp";